let swiper;

function initTargetSelector() {
  swiper = new Swiper('.landing-page-reviews .swiper', {
    speed: 400,
    spaceBetween: 25,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: false,
    initialSlide: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

window.onload = initTargetSelector();
